<template>
  <el-row type="flex" justify="space-between" class="vertical-center-box">
    <div class="vertical-center-box">
      <el-tag size="medium" class="mr-r4">
        이벤트 발생  {{convertValueByUnitData(total, 'count')}}건
      </el-tag>
      <ul class="icon-group-event">
        <li v-for="eventlevel in eventlevelCountList" :key="eventlevel.eventlevelId">
          <span class="icon-dot" :style="[{'background-color': eventlevel.eventlevelColorBg},{'margin-top':'1px'}]"></span>{{isNil(eventlevel.eventCount) ? 0 : convertValueByUnitData(eventlevel.eventCount, 'count')}}
        </li>
      </ul>
    </div>
    <div class="vertical-center-box">
      <i class="fal fa-caret-square-down" style="cursor:pointer;font-size:16px;font-weight:bold;color:#777" @click="clickOpenButton"></i>
    </div>
  </el-row>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import EventHistStatMixins from '@/mixins/event/event-hist-stats';
import EventHistAPI from '@/api/event/event-hist';

export default {
  name: 'WEventlevelCountBox',
  mixins: [EventHistStatMixins],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getOpenButtonClass() {
      if (this.isOpenStatsBox) {
        return 'far fa-caret-square-up';
      }
      return 'far fa-caret-square-down';
    },
    eventlevelCountList() {
      if (!isNil(this.eventlevelList)) {
        return cloneDeep(this.eventlevelList);
      }
      return [];
    },
  },
  data() {
    return {
      total: 0,
      isOpenStatsBox: false,
    };
  },
  watch: {
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.loadData();
        }
      },
      immediate: true,
    },
    selectedNode() {
      this.loadData();
    },
    analysisDateParams() {
      this.loadData();
    },
  },
  methods: {
    isNil,
    loadData() {
      if (!this.active) {
        return;
      }
      const params = {
        treeType: this.selectedTreeType,
        type: this.selectedNode.type,
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
      };
      this.setEventHistStatsParams(params);

      EventHistAPI.getEventHistStatsGroupByEventlevel(params).then((response) => {
        const result = response.data;
        const totalCount = result.data.filter((item) => item.eventlevelId === '_TOTAL')[0];
        this.total = totalCount.eventCount;
        if (result.success) {
          this.eventlevelCountList.forEach((item) => {
            const eventCount = result.data.filter((countItem) => countItem.eventlevelId === item.eventlevelId)[0];
            if (!isNil(eventCount)) {
              item.eventCount = eventCount.eventCount;
            }
          });
        }
      });
    },
    clickOpenButton() {
      // this.isOpenStatsBox = !this.isOpenStatsBox;
      this.$emit('click-open-stats-box-button');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/event-hist/components/EventlevelCountBox.vue